/**
 * Format phone number for display (XXX-XXX-XXXX)
 * @param {string} value - Raw phone number (numbers only)
 * @returns {string} - Formatted phone number
 */
export const formatPhoneNumber = (value) => {
  if (!value) return value;

  // Remove all non-numeric characters
  const phoneNumber = value.replace(/[^\d]/g, '');

  // Format based on length
  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength < 4) return phoneNumber;

  if (phoneNumberLength < 7) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
  }

  return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
};

/**
 * Format SSN for display (XXX-XX-XXXX)
 * @param {string} value - Raw SSN (numbers only)
 * @returns {string} - Formatted SSN
 */
export const formatSSN = (value) => {
  if (!value) return value;

  // Remove all non-numeric characters
  const ssn = value.replace(/[^\d]/g, '');

  // Format based on length
  const ssnLength = ssn.length;

  if (ssnLength < 4) return ssn;

  if (ssnLength < 6) {
    return `${ssn.slice(0, 3)}-${ssn.slice(3)}`;
  }

  return `${ssn.slice(0, 3)}-${ssn.slice(3, 5)}-${ssn.slice(5, 9)}`;
};

/**
 * Remove formatting from phone number (keep only numbers)
 * @param {string} value - Formatted phone number
 * @returns {string} - Numbers only
 */
export const unformatPhoneNumber = (value) => {
  if (!value) return value;
  return value.replace(/[^\d]/g, '');
};

/**
 * Remove formatting from SSN (keep only numbers)
 * @param {string} value - Formatted SSN
 * @returns {string} - Numbers only
 */
export const unformatSSN = (value) => {
  if (!value) return value;
  return value.replace(/[^\d]/g, '');
};
